module.exports = __webpack_public_path__ + "img/empty.662a075b.png";